import { humanize, statusTone, TONE_CLASSES } from '../reportFormat';

export function StatusBadge({ value }: { value: unknown }) {
  if (value === null || value === undefined || value === '') {
    return <span className="text-text-muted">—</span>;
  }
  const text = String(value);
  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${TONE_CLASSES[statusTone(text)]}`}
    >
      {humanize(text)}
    </span>
  );
}
